module.exports = __webpack_public_path__ + "fc49879c.png";